import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Pagination from 'rc-pagination';
import { useHistory, useLocation } from 'react-router-dom';
import { useQuery } from '../../../hooks/useQuery/useQuery';
import './Paginator.scss';

const Paginator = ({ pageSize, total, records, children, loading, pagePropName }) => {
  const query = useQuery();
  const { push } = useHistory();
  const { pathname } = useLocation();

  const urlPage = query?.[pagePropName] || 1;
  const initialPage = loading ? 1 : +urlPage;

  const [page, setPage] = useState(+initialPage);

  const calculateRenderedRecords = () => records.slice((page - 1) * pageSize, page * pageSize);
  const renderedRecords = useMemo(() => calculateRenderedRecords(), [records, page, pageSize]);

  const handlePageChange = (page) => {
    setPage(page);
  };

  useEffect(() => {
    if (loading) return;
    push(`${pathname}?page=${page}`);
  }, [page]);

  useEffect(() => {
    if (loading) return;
    if (urlPage) setPage(+urlPage);
  }, [urlPage, loading]);

  return (
    <>
      <>{children?.({ renderedRecords })}</>
      {records?.length / pageSize > 1 && (
        <div className="rc-paginator">
          <Pagination
            onChange={handlePageChange}
            current={page}
            pageSize={pageSize}
            total={records.length}
            showPrevNextJumpers
          />
        </div>
      )}
    </>
  );
};

Paginator.defaultProps = {
  pageSize: 4,
  records: [],
  children: null,
  total: 0,
  loading: false,
  pagePropName: 'page',
};

Paginator.propTypes = {
  pageSize: PropTypes.number,
  total: PropTypes.number,
  loading: PropTypes.bool,
  records: PropTypes.array,
  children: PropTypes.func,
  pagePropName: PropTypes.string, // this prop is added in case there two components using paginator in same page (for distinction)
};

export default Paginator;
